import $ from "jquery";

(function() {
  $.fn.injectForm = function(html) {
    return this.html(html).promise().done(function() {
      $('[autofocus]').focus();
    });
  };
}());
